import { FormControlLabel } from 'ui/FormControlLabel';
import { Radio } from 'ui/Radio';
import { FC, useState } from 'react';
import { clsx } from 'clsx';
export interface RadioButtonProps {
  item: string;
  selectedValue: string;
  onClick: (value: string) => void;
}
export const RadioButton: FC<RadioButtonProps> = ({
  selectedValue,
  item,
  onClick,
}) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <FormControlLabel
      onClick={() => onClick(item)}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      checked={selectedValue === item || isHovered}
      value={item}
      control={
        <Radio
          disableRipple
          sx={{
            '&.Mui-checked': {
              color: 'mainPalette.primary',
            },
          }}
        />
      }
      label={item}
      className={clsx(
        'm-0 flex w-full cursor-pointer items-center rounded-lg border p-1 pr-3 transition-all md:max-w-max md:hover:border-blue md:hover:text-blue',
        selectedValue === item && 'border-blue text-blue',
        selectedValue !== item && 'border-gray-500'
      )}
    />
  );
};
